import { render, staticRenderFns } from "./Correos.vue?vue&type=template&id=20b9b85c"
import script from "./Correos.vue?vue&type=script&lang=js"
export * from "./Correos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports